export const numberBitGetByPosition = (bin, position) => (bin & (1 << (position - 1))) >> (position - 1);
export const numberToRoman = (number) => {
    if (number < 1 || number > 3999) {
        throw new Error("Error: Input integer limited to 1 through 3,999");
    }
    const numerals = [
        ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
        ["X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC"],
        ["C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM"],
        ["M", "MM", "MMM"],
    ];
    const digits = Math.round(number).toString().split("");
    let position = digits.length - 1;
    return digits.reduce((roman, digit) => {
        if (digit !== "0") {
            roman += numerals[position][parseInt(digit) - 1];
        }
        position -= 1;
        return roman;
    }, "");
};
//# sourceMappingURL=number.js.map